import axios, { AxiosPromise } from "axios";
import store from "../store";
// import * as firebase from "firebase/app";
// import "firebase/auth";
import i18n from "../plugins/i18n";
import { AuthRequests } from "@/helpers/index";

export default function start() {
  axios.interceptors.request.use(
    config => {
      config.url = config.url += config.url!.includes("?")
        ? `&lang=${i18n.locale}`
        : `?lang=${i18n.locale}`;

      config.headers["Content-Type"] = "application/json";
      config.headers.Accept = "application/json";
      //const { currentUser } = firebase.auth();
      const currentUser = AuthRequests.autoAuthUser();
      if (currentUser) {
        if (currentUser.token) config.headers.Authorization = `Bearer ${currentUser.token}`;
      }
      return config;
    },
    error => {
      console.error(error);
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    response => {
      return response;
    },
    error => {
      const { config } = error;
      if (error.response == null) {
        console.error("error: ", error);
        return Promise.reject(error);
      }
      if (error.response.status === 401) {
        if (
          error.response.data.errors &&
          error.response.data.errors.base[0] === "Signature has expired"
        ) {
          const user = AuthRequests.autoAuthUser();
          if (user && user.token) {
            let token = user.token;
            store.commit("session/setNewToken", { token });
            config.headers.Authorization = `bearer ${token}`;
            return axios(config).catch(failure => {
                  console.error(
                  failure.response.status,
                  failure.response.request.responseURL,
                  failure
                );
              throw error;
            });
          }
        }
      }
      console.error(
        error.response.status,
        error.response.request.responseURL,
        error
      );

      return Promise.reject(error.response);
    }
  );
}
